(() => {
  if (window.kasopiaPhoneBrowseBound) return;
  window.kasopiaPhoneBrowseBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-kasopia-device]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(window.location.href);
    const device = link.dataset.kasopiaDevice;
    if (/\/collections\/(iphone-cases|samsung-cases)\/?$/.test(url.pathname)) {
      url.pathname = url.pathname.replace(/(iphone-cases|samsung-cases)\/?$/, 'phone-cases');
    }
    url.searchParams.delete('filter.p.m.custom.phone_type');
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    if (device) url.searchParams.set('filter.p.m.custom.phone_type', device);
    event.preventDefault();
    window.location.assign(url.href);
  });
})();
